import dotenv from "dotenv";

export const s3ConfigDev = {
  bucketName: process.env.REACT_APP_DEV_BUCKET_NAME!,
  region: "ap-southeast-1",
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID!,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY!,
};

export const s3ConfigProd = {
  // bucketName: process.env.REACT_APP_PROD_BUCKET_NAME!,
  bucketName: "merz2022",
  region: "ap-southeast-1",
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID!,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY!,
};
